module.exports = __webpack_public_path__ + "static/media/round.56709de6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/round.svg
// module id = 215
// module chunks = 1